import {
  excludeScreenFail,
  excludeScreenlogsFail,
  excludeScreenlogsSuccess,
  excludeScreenSuccess,
  getActivitySummaryError,
  getActivitySummarySuccess,
  getallprojectListError,
  getallprojectListSuccess,
  getprojectsummaryreportFail,
  getprojectsummaryreportscreensFail,
  getprojectsummaryreportscreensSuccess,
  getprojectsummaryreportSuccess,
  getUserTimeSheetReportError,
  getUserTimeSheetReportSuccess,
  screenVerifiedError,
  screenVerifiedSuccess,
  teamScreenlogsFail,
  teamScreenlogsSuccess,
  togglePageLoader,
} from "store/actions"
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import {
  PROJECT_LIST,
  TIMESHEET_USER,
  SCREEN_VERIFIED,
  ACTIVITY_SUMMARY,
  EXCLUDE_SCREEN_LOGS,
  EXCLUDE_SCREEN,
  TEAM_GET_SCREEN_LOGS,
  GET_PROJECT_SUMMARY_REPORT_SCREEN,
  GET_PROJECT_SUMMARY_WORK_REPORTS,
} from "./actionTypes"
import {
  get_ProjectList,
  post_VerifiedScreenList,
  post_UserTimeSheet,
  activitysummaryList,
  exclude_screen_logs,
  exclude_screen,
  get_team_screen_logs,
  getprojectsummaryreports,
  getprojectsummaryreportsView,
} from "helpers/backend_helper"

function* getTimeSheet({ payload: { timesheet } }) {
  // console.log("getTimeSheet  =====");

  try {
    yield put(togglePageLoader(true))
    const response = yield call(post_UserTimeSheet, timesheet)
    // console.log("GetTimeSheet Saga ", response);
    if (response.statusCode === 200) {
      yield put(getUserTimeSheetReportSuccess(response.data))
      yield put(togglePageLoader(false))
    } else {
      yield put(getUserTimeSheetReportError(response))
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(getUserTimeSheetReportError(error))
    yield put(togglePageLoader(false))
  }
}

function* getProjectList({ payload: { timesheet } }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(get_ProjectList, timesheet)
    // console.log("getProjectList Saga ", response);
    if (response.status === "Success") {
      yield put(getallprojectListSuccess(response.data))
      yield put(togglePageLoader(false))
    } else {
      yield put(getallprojectListError(response))
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(getallprojectListError(error))
    yield put(togglePageLoader(false))
  }
}
function* getscreenVerified({ payload: { screens }, callback }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(post_VerifiedScreenList, screens)
    if (response.status === "Success") {
      yield put(screenVerifiedSuccess(response.data))
      yield put(togglePageLoader(false))
      callback(response?.data)
    } else {
      yield put(screenVerifiedError(response))
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(screenVerifiedError(error))
    yield put(togglePageLoader(false))
  }
}

function* getactivitysummary({ payload: activity }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(activitysummaryList, activity)
    if (response.status === "Success") {
      yield put(getActivitySummarySuccess(response.data))
      yield put(togglePageLoader(false))
    } else {
      yield put(getActivitySummaryError(response))
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(getActivitySummaryError(error))
    yield put(togglePageLoader(false))
  }
}

function* excludescreen({ payload: exclude }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(exclude_screen, exclude)
    if (response.status === "Success") {
      yield put(excludeScreenSuccess(response))
      yield put(togglePageLoader(false))
      const delay = time => new Promise(resolve => setTimeout(resolve, time))
      yield call(delay,6000)
      yield put(excludeScreenSuccess({}))
    } else {
      yield put(excludeScreenFail(response))
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(excludeScreenFail(error))
    yield put(togglePageLoader(false))
  }
}
function* excludescreenlogs({ payload: excludelogs }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(exclude_screen_logs, excludelogs)
    if (response.status === "Success") {
      
      yield put(excludeScreenlogsSuccess(response))
      const delay = time => new Promise(resolve => setTimeout(resolve, time))
      yield call(delay,3000)
      yield put(excludeScreenlogsSuccess({}))
      yield put(togglePageLoader(false))
    } else {
      yield put(excludeScreenlogsFail(response))
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(excludeScreenlogsFail(error))
    yield put(togglePageLoader(false))
  }
}
// team based screen logs
function* teamscreenlogs({ payload: teamlogs }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(get_team_screen_logs, teamlogs)
    if (response.status === "Success") {
      
      yield put(teamScreenlogsSuccess(response))
      yield put(togglePageLoader(false))
    } else {
      yield put(teamScreenlogsFail(response))
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(teamScreenlogsFail(error))
    yield put(togglePageLoader(false))
  }
}
//hours report page
// team based screen logs
function* getProjectSummarylogs({ payload: teamlogs }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(getprojectsummaryreports, teamlogs)
    if (response.status === "Success") {
      
      yield put(getprojectsummaryreportscreensSuccess(response))
      yield put(togglePageLoader(false))
    } else {
      yield put(getprojectsummaryreportscreensFail(response))
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(getprojectsummaryreportscreensFail(error))
    yield put(togglePageLoader(false))
  }
}
//hours report page
// team based reports logs
function* getProjectSummaryReportslogs({ payload: teamlogs }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(getprojectsummaryreportsView, teamlogs)
    if (response.status === "Success") {
      
      yield put(getprojectsummaryreportSuccess(response))
      yield put(togglePageLoader(false))
    } else {
      yield put(getprojectsummaryreportFail(response))
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(getprojectsummaryreportFail(error))
    yield put(togglePageLoader(false))
  }
}

function* timesheetSaga() {
  yield takeEvery(TIMESHEET_USER, getTimeSheet)
  yield takeEvery(PROJECT_LIST, getProjectList)
  yield takeEvery(SCREEN_VERIFIED, getscreenVerified)
  yield takeEvery(ACTIVITY_SUMMARY, getactivitysummary)
  yield takeEvery(EXCLUDE_SCREEN, excludescreen)
  yield takeEvery(EXCLUDE_SCREEN_LOGS, excludescreenlogs)
  yield takeEvery(TEAM_GET_SCREEN_LOGS, teamscreenlogs)
  yield takeEvery(GET_PROJECT_SUMMARY_REPORT_SCREEN, getProjectSummarylogs)
  yield takeEvery(GET_PROJECT_SUMMARY_WORK_REPORTS, getProjectSummaryReportslogs)
}

export default timesheetSaga
